import { useQuery, keepPreviousData } from "@tanstack/react-query";
import {
  spySerpService,
  type SpyserpUrlStatsQueryParams,
} from "@/services/SpySerpService";
import { ensureSpyserpDateRange } from "@/hooks/spyserp/ensureSpyserpDateRange";

export type SpyserpUrlStatsQueryKeyInput = SpyserpUrlStatsQueryParams & {
  filtersParam: string | null;
};

export const getSpyserpUrlStatsQueryKey = ({
  filtersParam,
  ...params
}: SpyserpUrlStatsQueryKeyInput) =>
  ["spyserp", "urlStats", filtersParam, params] as const;

export const useSpyserpUrlStats = (params: SpyserpUrlStatsQueryKeyInput) =>
  useQuery({
    queryKey: getSpyserpUrlStatsQueryKey(params),
    queryFn: async () => {
      const resolved = await ensureSpyserpDateRange({
        dateRange: params.dateRange,
        customFrom: params.customFrom,
        customTo: params.customTo,
      });
      return spySerpService.getUrlStats(params, resolved);
    },
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5,
  });
